import { Reveal, Overline } from "./Reveal";

export const WhyBlocks = ({ overline, title, highlight, blocks, alt = false }) => (
  <section className={`py-24 lg:py-32 ${alt ? "bg-[var(--paper)]" : "bg-white"}`} data-testid={`why-blocks-${overline.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal><Overline>{overline}</Overline></Reveal>
            <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)] leading-[1.05]">{title} {highlight && <span className="italic text-accent">{highlight}</span>}</h2></Reveal>
          </div>
        </div>
        <div className="lg:col-span-8 space-y-8">
          {blocks.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.08}>
              <div className="flex gap-6 items-start pb-8 border-b border-[var(--line)] last:border-0">
                <span className="font-display text-2xl font-light text-accent w-10 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-[var(--primary)]">{b.title}</h3>
                  <p className="mt-2 text-[var(--muted)] leading-relaxed">{b.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
